<template>
  <v-container>
    <v-layout row wrap>
      <v-row>
        <v-flex xs12 sm6 md6>
          <div class="Subtitle-2 text-center font-weight-bold">{{titulo1}}</div>
          <div v-if="links1 != null" class="text-center">(Haga clic para observar el detalle)</div>
          <div :id="id1"></div>
          <div class="Subtitle-2 text-center">{{cifras}}</div>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <div class="text-center font-weight-bold">{{titulo2}}</div>
          <div v-if="links2 != null" class="text-center">(Haga clic para observar el detalle)</div>
          <div :id="id2"></div>
          <div class="text-center">{{cifras}}</div>
        </v-flex>
      </v-row>
    </v-layout>
  </v-container>
</template>
<script>
let router;
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
export default {
  name: "graf_dona",
  props: {
    avances1: {
      type: Array,
      required: true,
      default: null,
    },
    avances2: {
      type: Array,
      required: true,
      default: null,
    },
    nameseries1: {
        type: String,
        required:false
    },
    nameseries2: {
        type: String,
        required:false
    },
    links1: {
      type: Array,
      required: false,
      default: null,
    },
    links2: {
      type: Array,
      required: false,
      default: null,
    },
    id1: {
      type: String,
      required:true
    },
    id2: {
      type: String,
      required:true
    },
    titulo1: {
      type: String,
      required:true
    },
    titulo2: {
      type: String,
      required:true
    },
    cifras: {
      type: String,
      required:false
    }

  },
  data() {
    return {
      gaugeColors: [],
      colores: [],
      chart: "",
      legend: true,
    };
  },
  methods: {
    renderChart(tipechart, arraydatos, seriename) {
      if (arraydatos !== null) {
        if (arraydatos.length > 0) {
          this.limpiarchart(tipechart);
          let total = 0;
          let und = "bill";
          let unidad = "billones";

          if (und !== null && und.length > 0) und = " " + und;
          let chart = "";
          if (tipechart == "chart1") {
            chart = am4core.create(this.id1, am4charts.PieChart);
          } else {
            chart = am4core.create(this.id2, am4charts.PieChart);
          }
          chart.data = arraydatos;
          

          arraydatos.forEach((dato) => {
            total += dato.avance;
          });
          // this.colores.forEach(color => {
          //   this.pieColors.push(am4core.color(color));
          // });
          // chart.colors.list = this.pieColors;

          chart.innerRadius = 90;
          chart.radius = 75;
          chart.svgContainer.htmlElement.style.height = "420px";

          // Add label
          let label = chart.seriesContainer.createChild(am4core.Label);
          //label.text = total + "\r\n" + unidad;
          label.text =
            Intl.NumberFormat("es-CO", { maximumFractionDigits: 2 }).format(total) +
            "\r\n" +
            unidad;
          label.horizontalCenter = "middle";
          label.verticalCenter = "middle";
          // label.align = "center";
          // label.contentAlign = "center";
          label.textAlign = "middle";
          // label.isMeasured = false;
          // label.x = am4core.percent(50);
          // label.y = 0;
          label.fontSize = 25;

          // Add and configure Series
          let pieSeries = chart.series.push(new am4charts.PieSeries());
          pieSeries.dataFields.value = "avance";
          pieSeries.dataFields.category = seriename;
          pieSeries.labels.template.fontSize = 15;
          pieSeries.labels.template.paddingTop = 10;
          pieSeries.labels.template.paddingLeft = 10;
          pieSeries.labels.template.paddingRight = 10;
          pieSeries.labels.template.paddingBottom = 15;
          pieSeries.labels.template.maxWidth = 150;
          pieSeries.labels.template.wrap = true;
          pieSeries.labels.template.disabled = this.legend;

          pieSeries.slices.template.tooltipText =
            "{category} ({value.value}" + und + " - {value.percent} %)";

          pieSeries.slices.template.events.on("hit", (e) => {
            if (this.links1 != null)
            {
              let categoria = e.target.dataItem.category
              this.links1.forEach(element => {
                if (element.nombre == categoria)
                  router.push(element.link);
              });
            }

            if (this.links2 != null)
            {
              let categoria = e.target.dataItem.category
              this.links2.forEach(element => {
                if (element.nombre == categoria)
                  router.push(element.link);
              });
            }
          });
          pieSeries.labels.template.text =
            "{category} kiki ({value} " + unidad + "b.)";

          // Add a legend
          if (this.legend) {
            let size = 12;
            chart.legend = new am4charts.Legend();
            //   chart.legend.maxHeight = 300;
            //   chart.legend.maxWidth = 300;
            //   chart.legend.scrollable = true;
            // chart.legend.maxWidth = undefined;
            chart.legend.useDefaultMarker = true;
            let marker = chart.legend.markers.template.children.getIndex(0);
            marker.cornerRadius(size, size, size, size);
            
            chart.numberFormatter.numberFormat =  ("es-CO", { maximumFractionDigits: 2, minimumFractionDigits: 2 });
            marker.strokeWidth = 2;
            marker.strokeOpacity = 1;
            marker.stroke = am4core.color("#ccc");
            let markerTemplate = chart.legend.markers.template;
            markerTemplate.width = size;
            markerTemplate.height = size;
            // chart.legend.labels.template.text = "[bold {color}]{name}[/]";
            chart.legend.labels.template.text =
              "{category} ({value.value}" + und + " - {value.percent} %)";
            chart.legend.valueLabels.template.align = "right";
            chart.legend.valueLabels.template.textAlign = "end";
            chart.legend.valueLabels.template.fontSize = 15;
            chart.legend.valueLabels.template.disabled = true;
            // chart.legend.labels.template.maxWidth = 150;
            chart.legend.itemContainers.template.marginLeft = 0;
            chart.legend.itemContainers.template.paddingTop = 0;
            chart.legend.itemContainers.template.paddingBottom = 6;
            chart.legend.labels.template.truncate = false;
            // chart.legend.labels.template.wrap = true;
            chart.legend.labels.template.fontSize = 15;
            chart.legend.itemContainers.template.togglable = false;
            // chart.legend.itemContainers.template.tooltipText = "{legend}";
          }

          // Disable pulling out
          pieSeries.slices.template.states.getKey(
            "active"
          ).properties.shiftRadius = 0;

          // Add slice click event
          

          // 202007161205: Colores
          // https://stackoverflow.com/a/50376367
          if (this.colores !== null && this.colores.length > 0) {
            var colorSet = new am4core.ColorSet();
            colorSet.list = this.colores.map(function (color) {
              return new am4core.color(color);
            });
            pieSeries.colors = colorSet;
          }

          // https://github.com/amcharts/amcharts4/issues/1379#issuecomment-628088826
          if (chart.logo != undefined)
            chart.logo.height = -15000;

          if (tipechart == "chart1") {
            this.chart1 = chart;
          } else {
            this.chart2 = chart;
          }
          this.chart = chart;
        } else {
          this.limpiarchart(tipechart);
        }
      } else {
        this.limpiarchart(tipechart);
      }
    },
    limpiarchart(tipechart) {
      if (tipechart == "chart1")
        if (this.chart1) {
          this.chart1.dispose();
          document.getElementById(this.id1).style.height = 0;
        }
      if (tipechart == "chart2")
        if (this.chart2) {
          this.chart2.dispose();
          document.getElementById(this.id2).style.height = 0;
        }
    },
  },
  mounted() {
    router = this.$router;
    if (this.avances1.length > 0) {
      this.renderChart("chart1", this.avances1, this.nameseries1);
    }
    if (this.avances2.length > 0) {
      this.renderChart("chart2", this.avances2, this.nameseries2);
    }
  },
  watch: {
    avances1: function () {
      this.renderChart("chart1", this.avances1, this.nameseries1);
    },
    avances2: function () {
      this.renderChart("chart2", this.avances2, this.nameseries2);
    },
  },
  beforeDestroy() {
    if (this.chart1) {
      this.chart1.dispose();
    }
    if (this.chart2) {
      this.chart2.dispose();
    }
  },
};
</script>